import template from './sw-customer-detail.html.twig';

Shopware.Component.override('sw-customer-detail', {
    template,

    computed: {
        iorOpenCartsRoute() {
            return {
                name: 'neti.incomplete_order_reminder.customer.detail.open_carts',
                params: { id: this.customerId },
            };
        },
    }
});
